export namespace ScanTranslations {
  export const toasts = {
    shelfScanScannedProductNumberXYTimesToastTitle: 'shelfScanScannedProductNumberXYTimesToastTitle',
    shelfScanScannedProductNumberXToastTitle: 'shelfScanScannedProductNumberXToastTitle',
    shelfScanTotalScannedForProductNumberToastContent: 'shelfScanTotalScannedForProductNumberToastContent',

    shelfScanScannedMultipleProductNumbersToastTitle: 'shelfScanScannedMultipleProductNumbersToastTitle',
    shelfScanScannedMultipleProductNumbersToastContent: 'shelfScanScannedMultipleProductNumbersToastContent',

    shelfScanBinScannedToastTitle: 'shelfScanBinScannedToastTitle',
    shelfScanBinScannedToastContent: 'shelfScanBinScannedToastContent',

    scanModeRegularLabel: 'scanModeRegularLabel',
    scanModeShelfScanLabel: 'scanModeShelfScanLabel',
    scanModeListBuilderLabel: 'scanModeListBuilderLabel',

    onlyBinAllowedToastTitle: 'onlyBinAllowedToastTitle',
  } as const;
}
